import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
} from "@mui/material";
import { Button } from "@/app/global-components/button";
import { useNavigate } from "react-router-dom";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";
import { routes } from "@/consts";
import { AlertCircle } from "lucide-react";

interface CompanyWarningPopupProps {
  open: boolean;
}

const CompanyWarningPopup: React.FC<CompanyWarningPopupProps> = ({
  open = true,
}) => {
  const navigate = useNavigate();
  const { locale } = useLocale();
  const { t } = useTranslate(locale);

  const handleRedirect = () => {
    navigate(routes.settings);
  };

  return (
    <Dialog
      open={open}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          maxWidth: 420,
          m: 2,
        },
      }}
    >
      {/* Header */}
      <DialogTitle
        sx={{
          background: "linear-gradient(135deg, #f8fafc 0%, #ffffff 100%)",
          borderBottom: "1px solid #e5e7eb",
          p: 3,
          display: "flex",
          alignItems: "center",
          gap: 2,
        }}
      >
        <AlertCircle size={28} className="text-red-500 mr-2" />
        <Typography variant="h6" sx={{ fontWeight: 700, color: "#dc2626" }}>
          {t("alerts.warning.warning")}
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ p: 3 }}>
        <Box sx={{ py: 1 }}>
          <Typography
            variant="body1"
            color="error"
            gutterBottom
            sx={{ fontWeight: 600 }}
          >
            {t("company.notRegistered")}
          </Typography>
          <Typography variant="body2" sx={{ color: "#374151" }}>
            {t("company.registrationRequired")}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 3, pt: 0 }}>
        <Button
          className="w-full rounded-full !bg-black !text-white text-base font-semibold shadow hover:bg-gray-900 transition-all duration-150 py-3"
          style={{ background: "#18181b", color: "#fff" }}
          type="button"
          onClick={handleRedirect}
        >
          {t("actions.goToSettings")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CompanyWarningPopup;
